module.exports = __webpack_public_path__ + "img/switcprimary.d7589a7e.svg";